import HelmetMetaData from "@/components/HelmetMetaData";
import { Player } from "@lottiefiles/react-lottie-player";
import Successful from "@/lottie/success";
import { Link } from "react-router-dom";

const PaymentSuccessful = () => {
  return (
    <>
      <HelmetMetaData
        title="Payment Successful"
        description="Your payment has been processed successfully! Thank you for your purchase. You can now enjoy seamless connectivity and access to your services."
      />

      <div className="bg-[#22c55e flex h-screen flex-1 items-center justify-center">
        <div className="absolute top-0 z-0 h-[50%] w-full bg-primary"></div>
        <div className="z-50 flex w-[90%] flex-col justify-center rounded-xl bg-white px-5 pb-5 shadow md:w-[370px]">
          <div className="flex justify-end">
            <h2 className="ml-2 mt-3 w-fit rounded-md bg-primary/10 p-1 font-inter text-xs font-bold text-primary">
              Billzpay
            </h2>
          </div>
          <Player autoplay loop className="size-40" src={Successful} />

          <h1 className="text-center text-2xl font-semibold leading-[1.3]">
            Your payment successfully processed{" "}
          </h1>

          <div className="flex items-center justify-center">
            <p className="max-w-[18.4rem] pt-4 text-center text-[13px] text-gray-600">
              We’re excited to have you with us and are committed to providing
              you with an outstanding experience.
            </p>
          </div>

          <Link
            to="/dashboard"
            className="mt-12 rounded-md bg-primary py-2.5 text-center text-base font-medium text-white"
          >
            Back to website
          </Link>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccessful;
